<mtg-hockey-statistic-table-grouped
  *ngIf="sport.isHockey()"
  [sport]="sport"
  [statistic]="statistic"
  [pageSize]="pageSize"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
  [sortByDefender]="sortByDefender"
  [sortByForward]="sortByForward"
  [sortByGoalkeeper]="sortByGoalkeeper"
  [checkNewbie]="checkNewbie"
></mtg-hockey-statistic-table-grouped>
<mtg-football-statistic-table-grouped
  *ngIf="sport.isFootball()"
  [sport]="sport"
  [statistic]="statistic"
  [pageSize]="pageSize"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
></mtg-football-statistic-table-grouped>
<mtg-handball-statistic-table-grouped
  *ngIf="sport.isHandball()"
  [sport]="sport"
  [statistic]="statistic"
  [pageSize]="pageSize"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
></mtg-handball-statistic-table-grouped>
